import { SelectOption } from '@/types/form.type.ts';

export enum AuctionStatus {
    Draft = 'draft',
    AwaitingStart = 'awaiting_start',
    InProgress = 'in_progress',
    AwaitingResult = 'awaiting_result',
    Completed = 'completed',
    CompletedWithoutBids = 'completed_without_bids',
    Annulled = 'annulled',
}

export function getAuctionStatusLabel(status: AuctionStatus): string {
    switch (status) {
        case AuctionStatus.Draft:
            return 'Черновик';
        case AuctionStatus.AwaitingStart:
            return 'Ожидает запуска';
        case AuctionStatus.InProgress:
            return 'Запущен';
        case AuctionStatus.AwaitingResult:
            return 'Ожидает результата';
        case AuctionStatus.Completed:
            return 'Завершен';
        case AuctionStatus.CompletedWithoutBids:
            return 'Завершен без ставок';
        case AuctionStatus.Annulled:
            return 'Аннулирован';
    }
}

export function getAuctionStatusSelectOptions(isAdmin: boolean = false): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(AuctionStatus)
        .filter((status) => isAdmin || status !== AuctionStatus.Draft)
        .forEach((status: AuctionStatus) => {
            options.push({
                label: getAuctionStatusLabel(status),
                value: status,
            });
        });

    return options;
}
